import React from 'react';
import {
  ModalOverlay,
  ModalDialog,
  ModalTitle,
  ModalMessage,
  ModalButtonGroup,
  ModalButton,
} from '../styles/modal';

interface WhatsAppLogoutDialogProps {
  isOpen: boolean;
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const WhatsAppLogoutDialog: React.FC<WhatsAppLogoutDialogProps> = ({
  isOpen,
  isLoading = false,
  onConfirm,
  onCancel,
}) => (
  <ModalOverlay $isOpen={isOpen} onClick={isLoading ? undefined : onCancel}>
    <ModalDialog onClick={e => e.stopPropagation()}>
      <ModalTitle>Disconnect WhatsApp?</ModalTitle>
      <ModalMessage>
        Are you sure you want to disconnect WhatsApp for this location? You can scan the QR code
        again to reconnect.
      </ModalMessage>
      <ModalButtonGroup>
        <ModalButton onClick={onCancel} disabled={isLoading}>
          Cancel
        </ModalButton>
        <ModalButton $primary onClick={onConfirm} disabled={isLoading}>
          {isLoading ? 'Disconnecting...' : 'Yes, Disconnect'}
        </ModalButton>
      </ModalButtonGroup>
    </ModalDialog>
  </ModalOverlay>
);

export default WhatsAppLogoutDialog;
